import React from 'react'
import HeroSection from '../components/HeroSection'
import { NavLink } from 'react-router-dom';

function Home() {
    return (
        <>


            <div>
                <h1 className="text-center mt-5 mb-3">Come, Lets explore the world together</h1>
                <HeroSection />
            </div>

            <div >
                <div className="row row-cols-1 row-cols-md-3 g-4 mx-5">
                    <div className="col md-4" >
                        <div className="card h-100" style={{ width: '18rem', alignContent: 'center', border: '1px solid gray' }}>
                            <img src="/images/service.jpg" className="card-img-top" alt="..." />
                            <div className="card-body">
                                <h5 className="card-title text-center">Services</h5>
                                <p className="card-text">Have a look at some of our services to premium locations.</p>
                            </div>
                            <NavLink exact className="nav-link  text-center" to="/services">
                                <button type="button" class="btn btn-primary">Our Services</button>
                            </NavLink>
                        </div>
                    </div>

                    <div className="col md-4">
                        <div className="card h-100" style={{ width: '18rem', border: '1px solid gray'  }}>
                            <img src="/images/flight.jpg" className="card-img-top" alt="..." />
                            <div className="card-body">
                                <h5 className="card-title text-center">Book Your flights here</h5>
                                <p className="card-text">Book your flights as soon as possible and explore the world</p>
                            </div>
                            <a href={"https://www.google.com/travel/flights"} className="btn btn-primary ">Book here</a>
                        </div>
                    </div>

                    <div className="col md-4">
                        <div className="card h-100" style={{ width: '18rem', border: '1px solid gray'  }}>
                            <img src="/images/activities.jpg" className="card-img-top" alt="..." />
                            <div className="card-body">
                                <h5 className="card-title text-center">Our Activities</h5>
                                <p className="card-text">Have a look at some people and their reviews about our services. Visit us and enjoy </p>
                            </div>
                            <NavLink exact className="nav-link  text-center" to="/activities" style={{width:'18rem'}}>
                                <button type="button" class="btn btn-primary">Activities</button>
                            </NavLink>

                        </div>
                    </div>

                    
                </div>
            </div>
        </>
    )
}

export default Home
